import { useMemo } from 'react'

import { Controller, useFormContext } from 'react-hook-form'

import { ContentModuleType } from '@tribeplatform/gql-client/types'
import { useNetworkContentModules } from '@tribeplatform/react-sdk/hooks'

import { FormSpacePicker } from '../../Form/FormSpacePicker.js'
import { T, useI18n } from '../../i18n/index.js'

export const EventSpacePicker = () => {
  const { control } = useFormContext()
  const { $t } = useI18n()
  const { data: networkContentModules } = useNetworkContentModules()
  const allSpaces = useMemo(() => {
    const eventModules = networkContentModules?.filter(
      module => module.contentModuleType === ContentModuleType.event,
    )
    return eventModules.flatMap(
      module => module.authMemberProps?.availableSpaces,
    )
  }, [networkContentModules])

  return (
    <Controller
      control={control}
      name="targetSpace"
      render={({ field }) => (
        <FormSpacePicker
          label={
            <T
              id="Event.Form.SpacePicker.Label"
              defaultMessage="Create event in"
            />
          }
          name={field.name}
          onChange={field.onChange}
          value={field.value}
          validation={{
            required: {
              value: true,
              message: $t({
                id: 'Generic.FieldIsRequired',
                defaultMessage: 'This field is required.',
              }),
            },
          }}
          options={allSpaces}
        />
      )}
    />
  )
}
